export default __webpack_public_path__ + "static/media/Ballroll_00107.f2e90c8a.png";